<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="breadcrumb-help-container mb-3">
      <div class="breadcrumb-container">
        <router-link v-if="modulo != 0" to="/usuario">Usuarios</router-link>
        <span v-if="modulo != 0">> {{ datoUsuario.nombre }}</span>
        <router-link v-else to="/MenuPrincipal">Inicio</router-link>
      </div>
      <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
        @click="showModalHelp = true">help
      </span>
    </div>
    <Modal v-model:modelValue="showModalHelp">
      <AyudaUsuario />
    </Modal>
    <hr>
    <!-- Resumen de configuración de usuario -->
    <div class="modal-dialog modal-xl" style="z-index: 1;">
      <div class="modal-content">
        <div class="modal-body">
          <!-- Información de Usuario -->
          <div class="user-info mb-3">
            <div class="row">
              <div class="col-5">
                <label for="nombre" class="form-label">Nombre</label>
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoUsuario.nombre" disabled>
              </div>
              <div class="col-5">
                <label for="idPerfil" class="form-label">Perfil</label>
                <input type="text" class="form-control" id="perfilNombre" name="perfilNombre"
                  v-model="datoUsuario.perfilNombre" disabled>
              </div>
              <div class="col-2">
                <label for="suscriptor" class="form-label">Suscriptor</label>
                <input type="text" class="form-control" v-model="suscriptorText" disabled>
              </div>
            </div>
          </div>
          <!-- Modulos y Menús -->
          <div class="modules-menus mb-3">
            <div class="row">
              <div class="col-3">
                <label for="moduloAdministracion" class="form-label">Módulo Administración</label>
                <input type="text" class="form-control" v-model="moduloAdministracionText" disabled>
              </div>
              <div class="col-3">
                <label for="moduloAtencion" class="form-label">Módulo Atención</label>
                <input type="text" class="form-control" v-model="moduloAtencionText" disabled>
              </div>
              <div class="col-3">
                <label for="moduloFacturacion" class="form-label">Módulo Facturación</label>
                <input type="text" class="form-control" v-model="moduloFacturacionText" disabled>
              </div>
              <div class="col-3">
                <label for="moduloDashboards" class="form-label">Módulo Dashboards</label>
                <input type="text" class="form-control" v-model="moduloDashboardsText" disabled>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label for="menuParametros" class="form-label">Menú Parámetros</label>
                <input type="text" class="form-control" v-model="menuParametrosText" disabled>
              </div>
              <div class="col-3">
                <label for="menuProcesos" class="form-label">Menú Procesos</label>
                <input type="text" class="form-control" v-model="menuProcesosText" disabled>
              </div>
              <div class="col-3">
                <label for="menuReportes" class="form-label">Menú Reportes</label>
                <input type="text" class="form-control" v-model="menuReportesText" disabled>
              </div>
              <div class="col-3">
                <label for="menuAyuda" class="form-label">Menú Ayuda</label>
                <input type="text" class="form-control" v-model="menuAyudaText" disabled>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label for="opcionConsulta" class="form-label">Opción Consulta</label>
                <input type="text" class="form-control" v-model="opcionConsultaText" disabled>
              </div>
              <div class="col-3">
                <label for="opcionOperaciones" class="form-label">Opción Operaciones</label>
                <input type="text" class="form-control" v-model="opcionOperacionesText" disabled>
              </div>
              <div class="col-3">
                <label for="opcionDescarga" class="form-label">Opción Descarga</label>
                <input type="text" class="form-control" v-model="opcionDescargaText" disabled>
              </div>
              <div class="col-3">
                <label for="opcionMenu" class="form-label">Opción Menú</label>
                <input type="text" class="form-control" v-model="opcionMenuText" disabled>
              </div>
            </div>
          </div>
          <div v-if="mostrarBloque" class="additional-info mb-3">
            <div class="row">
              <div class="col-2">
                <label for="idUsuario" class="form-label">Id Usuario</label>
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoUsuario.idUsuario" disabled>
              </div>
              <div class="col-2">
                <label for="idSuscripcion" class="form-label">Suscripción</label>
                <input type="text" class="form-control" id="idSuscripcion" name="idSuscripcion" v-model="datoUsuario.idSuscripcion" disabled>
              </div>
              <div class="col-2">
                <label for="idUsuarioReg" class="form-label">Id Usuario Reg</label>
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoUsuario.idUsuarioReg" disabled>
              </div>
              <div class="col-2">
                <label for="fechaReg" class="form-label">Fecha Reg</label>
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" :value="getFormattedDate(datoUsuario.fechaReg)" disabled>
              </div>
              <div class="col-2">
                <label for="idUsuarioAct" class="form-label">Id Usuario Act</label>
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoUsuario.idUsuarioAct" disabled>
              </div>
              <div class="col-2">
                <label for="fechaAct" class="form-label">Fecha Act</label>
                <input type="text" class="form-control" id="fechaAct" name="fechaAct" :value="getFormattedDate(datoUsuario.fechaAct)" disabled>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-8">
                <button @click.prevent="mostrarOcultarBloque" class="btn btn-light">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
              </div>
              <div class="col-4 text-right">
                <router-link class="btn btn-outline-primary" :to="`/personaform/${p_idPersona}`">Configura tu información personal</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="datoUsuario.suscriptor === 1" class="suscriptor-info mb-4">
      <p>Como usuario suscriptor, tienes opciones de administración del sistema y también puedes registrarte como médico:</p>
    </div>

    <div class="row">
      <div class="col-12 text-center">
        <button @click="registrarMedico" class="btn btn-primary botonRegistro">Soy Médico - Registrarme</button>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaUsuario from '@/views/ayuda/AyudaUsuario.vue'
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";

export default {
  components: {
    Layout, Footer, AyudaUsuario
  },
  data() {
    return {
      usuarios: [],
      datoUsuario: {},
      mostrarBloque: false,
      p_idUsuario: 0,
      p_idPersona: 0,
      modulo: 0,
      showModalHelp: false,
    }
  },
  computed: {
    moduloAdministracionText() {
      return this.datoUsuario.moduloAdministracion ? 'Sí' : 'No';
    },
    moduloAtencionText() {
      return this.datoUsuario.moduloAtencion ? 'Sí' : 'No';
    },
    moduloFacturacionText() {
      return this.datoUsuario.moduloFacturacion ? 'Sí' : 'No';
    },
    moduloDashboardsText() {
      return this.datoUsuario.moduloDashboards ? 'Sí' : 'No';
    },
    menuParametrosText() {
      return this.datoUsuario.menuParametros ? 'Sí' : 'No';
    },
    menuProcesosText() {
      return this.datoUsuario.menuProcesos ? 'Sí' : 'No';
    },
    menuReportesText() {
      return this.datoUsuario.menuReportes ? 'Sí' : 'No';
    },
    menuAyudaText() {
      return this.datoUsuario.menuAyuda ? 'Sí' : 'No';
    },
    opcionConsultaText() {
      return this.datoUsuario.opcionConsulta ? 'Sí' : 'No';
    },
    opcionOperacionesText() {
      return this.datoUsuario.opcionOperaciones ? 'Sí' : 'No';
    },
    opcionDescargaText() {
      return this.datoUsuario.opcionDescarga ? 'Sí' : 'No';
    },
    opcionMenuText() {
      return this.datoUsuario.opcionMenu ? 'Sí' : 'No';
    },
    suscriptorText() {
      return this.datoUsuario.suscriptor ? 'Sí' : 'No';
    }
  },
  mounted() {
    this.p_idUsuario = this.$route.params.p_idusuario
    this.modulo = window.sessionStorage.getItem("modulo")
    this.p_idPersona = window.sessionStorage.getItem("idPersona");
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    getData() {
      api.get('/vwusuarios/' + this.p_idUsuario)
        .then(response => {
          this.datoUsuario = response.data;
        })
        .catch(error => {
          console.error('Error al obtener datos de la persona:', error);
        });
    },
    registrarMedico() {
      this.$router.push('/medico02/' + this.datoUsuario.idPersona);
    },
    registrarAdministrativo() {
      this.$router.push('/usuarioadm02/' + this.datoUsuario.idPersona);
    }
  }
}
</script>

<style scoped>
.breadcrumb-help-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.help-icon {
  font-size: 32px;
  color: blue;
  cursor: pointer;
}

.modal-dialog {
  margin-top: 20px;
}

.user-info, .modules-menus, .additional-info {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 5px;
}

.user-info .form-label, .modules-menus .form-label, .additional-info .form-label {
  font-weight: bold;
}

.botonRegistro {
  margin: 5px;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.botonRegistro:hover {
  background-color: #45a049;
}

.suscriptor-info {
  text-align: center;
  margin-top: 20px;
}

.btn-link {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}
</style>